import { nameOfFactory } from "@libs/utils/name-of.utils.ts";
import { ReviewFormValues } from "@shared-types/acc/claim-review-values.interface.ts";

export const reviewFormNameOf = nameOfFactory<ReviewFormValues>();
